import AffiliationsTable from './AffiliationsTable';

export default AffiliationsTable;
